import { HttpErrorResponse } from "@angular/common/http";

type MaybeErrorPayload =
  | {
      i18nErrorCode?: unknown;
      message?: unknown;
      body?: any;
      error?: any;
    }
  | any;

/**
 * Extract i18nErrorCode from backend error shapes:
 * - { i18nErrorCode, message, status, ... }
 * - Angular HttpErrorResponse where payload is in error.error or error.body
 */
export function getI18nErrorCodeFromHttpError(
  err: unknown,
): string | null {
  const http = err as HttpErrorResponse | undefined;
  const payload: MaybeErrorPayload | undefined =
    (http as any)?.error ?? (http as any)?.body ?? (err as any);

  const code =
    payload?.i18nErrorCode ??
    payload?.body?.i18nErrorCode ??
    payload?.error?.i18nErrorCode;

  return typeof code === "string" && code.trim() ? code.trim() : null;
}

